<!-- Desktop template -->
<mat-expansion-panel id="quotesWidgetPanel" [expanded]="panelExpanded" hideToggle *appIsDesktop>
  <mat-expansion-panel-header id="quotesWidgetPanelHeader" (click)="expandPanel($event)">
    <mat-panel-title id="open_quotes_container" class="title-container">
      <!-- Widget Title -->
      <div class="flex-container">
        <typography id="open_quotes_title" variant="mat-headline-6" weight="bold">
          {{ title || noOpenQuotesTitle }}
        </typography>
        <span id="quotes-widget-header-closed"
        class="crm-industrial-font icon-keyboard-arrow-down"></span>
        <span id="quotes-widget-header-opened"
        class="crm-industrial-font icon-keyboard-arrow-up"></span>
      </div>

      <div id="quotesWidgetButtonBar" class="button-bar">
        <ds-button [label]="appStrings.button_seeAll" id="seeAllQuotesButton" (onClick)="navigateToOpenQuotes($event)"
          type="primary" variant="label-only" type="secondary" size="medium">
        </ds-button>
        @if (customerId) {
          <ds-button type="primary" id="newQuoteButton" variant="label-only" size="medium"
            [disabled]="electronAppOutOfSync" (onClick)="navigateToNewQuote()" [label]="appStrings.button_newQuote">
          </ds-button>
        } @else {
          <!-- Add validation for leadInfo status to be Validate or in progress -->
          @if (leadId) {
            <ds-button type="primary" id="newQuoteForLeadButton" variant="label-only"
              [disabled]="electronAppOutOfSync" (onClick)="navigateToNewLeadQuote()" [label]="appStrings.button_newQuote"
              size="medium">
            </ds-button>
          } @else {
            <ds-button type="primary" id="newGenericQuoteButton" variant="label-only" [isDisabled]="electronAppOutOfSync"
              (onClick)="navigateToNewGenericQuote()" [label]="appStrings.button_newQuote" size="medium">
            </ds-button>
          }
        }
      </div>
    </mat-panel-title>
  </mat-expansion-panel-header>

  <!-- Quotes list -->
  <ds-divider></ds-divider>
  <div id="quotesSearchContainer" (click)="$event.stopPropagation()" class="search-container">
    <app-last-quotes-search id="quotesSearch" (filterChanged)="getQuoteList($event)" [customer]="null"
      [isCustomerDashboard]="customerId || leadId ? true : false" [filters]="quotesFilters"
    [isFromDashboard]="true"></app-last-quotes-search>
  </div>
  @if (quotesList && quotesList.length > 0) {
    <div id="quotesTableContainer">
      @if (quotesList.length && !loading) {
        <ds-table id="openQuotesTable" [dataSource]="quotesList"
          [displayedColumns]="displayedColumns">
          <!-- Quote Name  -->
          <ng-container matColumnDef="QuoteName">
            <th mat-header-cell id="quoteNameHeader" [hidden]="accountManagerEmployeeId" *matHeaderCellDef>
              {{ appStrings.label_quoteName }}
            </th>
            <td mat-cell [hidden]="accountManagerEmployeeId" [id]="'quoteName_'+row"
              *matCellDef="let element; let row= dataIndex;">
              @if (element.quoteName) {
                <span>{{ element.quoteName }}</span>
              } @else {
                @if (!element.quoteName) {
                  <span>—</span>
                }
              }
            </td>
          </ng-container>
          <!-- Customer Name -->
          <ng-container matColumnDef="CustomerName">
            <th mat-header-cell id="customerNameHeader" [hidden]="customerId || leadId" *matHeaderCellDef>
              {{ appStrings.quoteSearch_customerName }}
            </th>
            <td mat-cell [hidden]="customerId || leadId" [id]="'accountName_'+row" *matCellDef="let element; let row= dataIndex;">
              <span>{{ element.accountName }}</span>
            </td>
          </ng-container>
          <!-- Confidence to Close -->
          <ng-container matColumnDef="Confidence">
            <th mat-header-cell id="confidenceHeader" *matHeaderCellDef>
              {{ appStrings.quoteSearch_confidencePct }}
            </th>
            <td mat-cell *matCellDef="let element;let index = dataIndex"
              [id]="'confidenceToClose_'+index">
              {{ confidenceToCloseNames[confidenceToClose[element.confidenceToClosePercentageId]] }}
            </td>
          </ng-container>
          <!-- Quote Number -->
          <ng-container matColumnDef="Number">
            <th mat-header-cell id="quoteNumberHeader" *matHeaderCellDef>{{appStrings.label_number}} </th>
            <td mat-cell [id]="'quoteNumber_'+row" *matCellDef="let element; let row= dataIndex;">
              @if (!element.migratedQuoteNumber) {
                <span>
                  {{ element.quoteNumber }}
                </span>
              } @else {
                <span>{{ element.migratedQuoteNumber }}</span>
              }
            </td>
          </ng-container>
          <!-- Expire Date Column -->
          <ng-container matColumnDef="ExpireDate">
            <th mat-header-cell id="expireDateHeader" *matHeaderCellDef>{{ appStrings.label_expiredDate }} </th>
            <td mat-cell [id]="'expireDate_'+row" *matCellDef="let element; let row= dataIndex;">
              {{ element.expiredDate | date: dateFormat }}
            </td>
          </ng-container>
          <!-- Total Column -->
          <ng-container matColumnDef="Total">
            <th mat-header-cell id="totalHeader" *matHeaderCellDef>
              {{ appStrings.label_total }}
            </th>
            <td mat-cell [id]="'total_'+row" *matCellDef="let element; let row= dataIndex;">
              {{ element.total | currency: element.currencySign }}
            </td>
          </ng-container>
          <!-- Edit Column -->
          <ng-container matColumnDef="Edit">
            <th mat-header-cell id="editHeader" *matHeaderCellDef></th>
            <td mat-cell [id]="'edit_'+row" *matCellDef="let element; let row= dataIndex;">
              <ds-button type="tertiary" variant="label-icon" icon="edit" (onClick)="goToQuoteDetails(element)"
              [label]="appStrings.label_edit" iconStyle="material-icons-outlined" size="medium" id="editButton_{{row}}"></ds-button>
            </td>
          </ng-container>
        </ds-table>
      }
    </div>
  } @else {
    <ng-template [ngTemplateOutlet]="loading ? null : no_results"></ng-template>
  }

  <!-- Loading container -->
  @if (loading) {
    <div class="loading-container">
      <typography variant="mat-body-1" weight="regular">{{ appStrings.loadingQuotes }}</typography>
      <ds-progress-spinner progress_mode="indeterminate" id="loadingQuotes"></ds-progress-spinner>
    </div>
  }

  <!-- Pagination -->
  @if (quotesList?.length > 0) {
    <div id="paginationContainer" class="pagination-container">
      <div id="pageCount" class="page-count">
        @if (!loading) {
          <div id="pageCountText">
            <b>{{ pageOffset + 1 }} - {{ pageOffset + (quotesList?.length ?? 0) }}</b> {{appStrings.pagination_of}} <b>{{ totalRecords }}</b>
          </div>
        }
      </div>
      <div id="pagination-wrapper">
        <ds-pagination
          id="quotes-widget-pagination"
          [totalPages]="totalPages"
          paginationDisplay="large"
          buttonTypes="nextPrevFirstLast"
          (pageChanged)="loadPage($event)"
        ></ds-pagination>
      </div>
      <div class="flex-item-2"></div>
    </div>
  }

  <ng-template #no_results>
    <div id="noResults" class="no-results">
      <typography id="noResultsText" variant="mat-subtitle-1" weight="regular">
        {{ appStrings.leads_noResults }}
      </typography>
    </div>
  </ng-template>
</mat-expansion-panel>

<!-- Mobile template -->
<ds-paper *appIsMobile elevation="elevation_none" borderRadius="radius_S" outline="outlined" class="mobile-paper-nested-panel"
  insidePaddingTop="top-spacing_none" insidePaddingBottom="bottom-spacing_none" insidePaddingLeft="left-spacing_none" insidePaddingRight="right-spacing_none">
  <mat-expansion-panel [expanded]="panelExpanded" hideToggle class="mobile mobile-nested-panel">
    <mat-expansion-panel-header id="quotesWidgetPanelHeaderMobile" (click)="expandPanel($event)">
      <mat-panel-title id="open_quotes_container_mobile" class="title-container">
        <span class="quotes-header-title">
          <span id="quotes-title" class="title"> {{ title || noOpenQuotesTitle }} </span>
        </span>
        <span id="quotes-widget-header-closed"
        class="crm-industrial-font icon-keyboard-arrow-down"></span>
        <span id="quotes-widget-header-opened"
        class="crm-industrial-font icon-keyboard-arrow-up"></span>
      </mat-panel-title>
    </mat-expansion-panel-header>
    <ds-divider></ds-divider>
    <div id="quotesSearchContainerMobile" (click)="$event.stopPropagation()" class="search-container">
      <app-last-quotes-search id="quotesSearchMobile" (filterChanged)="getQuoteList($event)" [customer]="null"
        [isCustomerDashboard]="customerId || leadId ? true : false" [filters]="quotesFilters"
      [isFromDashboard]="true"></app-last-quotes-search>
    </div>
    @if (loading) {
      <div id="quotesLoadingMobile" class="loading">
        <ds-progress-spinner id="loadingQuotesMobile" progress_mode="indeterminate"></ds-progress-spinner>
      </div>
    }
    @if (!loading) {
      <div>
        @if (quotesList && quotesList.length > 0) {
          <div>
            @for (quote of quotesList; track quote; let i = $index) {
              <mat-expansion-panel hideToggle class="mobile-card two-columns grey blue-border tall" [expanded]="false">
                <mat-expansion-panel-header>
                  <mat-panel-title id="quote-card-header-container" class="card-header-container">
                    <span class="card-header">
                      <span id="quote-card-title" class="title"> {{ quote.quoteName || '—' }} </span>
                      <span id="quote-card-subtitle" class="subtitle">
                        {{ quote.total | currency: quote.currencySign }}
                      </span>
                    </span>
                    <div class="mobile-card-header-actions">
                      <ds-button [id]="'edit_mobile_button_'+i" size="medium" type="tertiary" variant="icon-only" (onClick)="goToQuoteDetails(quote)"
                        icon="edit" iconStyle="material-icons-outlined">
                      </ds-button>
                      <span id="quotes-header-closed"
                      class="crm-industrial-font icon-keyboard-arrow-down"></span>
                      <span id="quotes-header-opened"
                      class="crm-industrial-font icon-keyboard-arrow-up"></span>
                    </div>
                  </mat-panel-title>
                </mat-expansion-panel-header>
                <ds-divider></ds-divider>
                <div class="content">
                  @if (!customerId && !leadId) {
                    <div class="row">
                      <div class="column full-width">
                        <typography [id]="'customer_label_'+i" class="label" variant="caption-2" weight="regular"> {{ appStrings.quoteSearch_customerName }} </typography>
                        <typography [id]="'customer_'+i" variant="body-2" weight="medium"> {{ quote.accountName }} </typography>
                      </div>
                    </div>
                  }
                  <div class="row">
                    <div class="column">
                      <typography [id]="'confidence_label_'+i" class="label" variant="caption-2" weight="regular"> {{ appStrings.quoteSearch_confidencePct }} </typography>
                      <typography [id]="'confidence_'+i" variant="body-2" weight="medium">
                        {{ confidenceToCloseNames[confidenceToClose[quote.confidenceToClosePercentageId]] }}
                      </typography>
                    </div>
                    <div class="column">
                      <typography [id]="'expire_label_'+i" class="label" variant="caption-2" weight="regular"> {{ appStrings.label_expiredDate }} </typography>
                      <typography [id]="'expire_'+i" variant="body-2" weight="medium"> {{ quote.expiredDate | date: dateFormat }} </typography>
                    </div>
                  </div>
                  <div class="row">
                    <div class="column full-width">
                      <typography [id]="'quote_number_label_'+i" class="label" variant="caption-2" weight="regular"> {{ appStrings.quote_quoteNumber }} </typography>
                      <typography [id]="'quote_number_'+i" variant="body-2" weight="medium"> {{ !quote.migratedQuoteNumber ? quote.quoteNumber : quote.migratedQuoteNumber }} </typography>
                    </div>
                  </div>
                </div>
              </mat-expansion-panel>
            }
          </div>
        } @else {
          <div id="noResultsMobile" class="no-results">
            <typography variant="mat-subtitle-1" weight="regular">
              {{ appStrings.leads_noResults }}
            </typography>
          </div>
        }
      </div>
    }
    <!-- Pagination Mobile -->
    @if (quotesList?.length > 0) {
      <div id="paginationContainerMobile" class="pagination-container-mobile">
        <div id="pageCountMobile" class="page-count">
          @if (!loading) {
            <div id="pageCountTextMobile">
              <b>{{ pageOffset + 1 }} - {{ pageOffset + (quotesList?.length ?? 0) }}</b> {{appStrings.pagination_of}} <b>{{ totalRecords }}</b>
            </div>
          }
        </div>
        <div id="pagination-wrapper-mobile">
          <ds-pagination
            id="quotes-widget-pagination-mobile"
            [totalPages]="totalPages"
            paginationDisplay="large"
            buttonTypes="nextPrevFirstLast"
            (pageChanged)="loadPage($event)"
          ></ds-pagination>
        </div>
      </div>
    }
  </mat-expansion-panel>
  @if (customerId || leadId) {
    <div class="mobile-nested-panel-footer">
      <ds-divider></ds-divider>
      <div class="button-container mobile-nested-panel-footer-actions">
        <ds-button [label]="appStrings.button_seeAll" id="seeAllQuotesButtonMobile" (onClick)="navigateToOpenQuotes($event)"
          size="medium" type="secondary" variant="label-only">
        </ds-button>
        @if (customerId) {
          <ds-button type="primary" id="newQuoteButtonMobile" variant="label-only" size="medium"
            [disabled]="electronAppOutOfSync" (onClick)="navigateToNewQuote()" [label]="appStrings.button_newQuote">
          </ds-button>
        } @else {
          @if (leadId) {
            <ds-button type="primary" id="newQuoteForLeadButtonMobile" variant="label-only"
              [disabled]="electronAppOutOfSync" (onClick)="navigateToNewLeadQuote()" [label]="appStrings.button_newQuote"
              size="medium">
            </ds-button>
          } @else {
            <ds-button type="primary" id="newGenericQuoteButtonMobile" variant="label-only" [disabled]="electronAppOutOfSync"
              (onClick)="navigateToNewGenericQuote()" [label]="appStrings.button_newQuote" size="medium">
            </ds-button>
          }
        }
      </div>
    </div>
  }
</ds-paper>

